import { useState } from 'react'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import DepositDetailsDrawer from 'src/app/pages/accounting/documents/deposit-details/deposit-details.drawer'
import { Button, Stack } from '@vapor/material'
import { useTranslation } from 'react-i18next'

type PosDepositInfoProps = {
  totalDepositAmount: number
  posDepositDocumentIds: string[]
}

export const PosDepositInfo = (props: PosDepositInfoProps) => {
  const { totalDepositAmount, posDepositDocumentIds } = props
  const {t} = useTranslation()
  const { currency } = useTenant()
  const { formatCurrency } = useFormatCurrency()

  const [openDepositDrawer, setOpenDepositDrawer] = useState<boolean>(false)

  return (
    <>
      <Button //
        variant="text"
        size="small"
        onClick={() => setOpenDepositDrawer(true)}
      >
        <Stack direction="row" spacing={0.5} alignItems={'center'}>
          <span>{`${t('pms.booking.reservation.checkout_document.deposits_title')}:`}</span>
          <span>{formatCurrency(totalDepositAmount, currency)}</span>
        </Stack>
      </Button>
      <DepositDetailsDrawer open={openDepositDrawer} onClose={() => setOpenDepositDrawer(false)} posDepositDocumentIds={posDepositDocumentIds} />
    </>
  )
}
